import {Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ViewChild, ElementRef, HostListener} from '@angular/core';
import {Product} from "../shop/shop.product.model";
import {OptionService} from "../option/option.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AmountComponent} from "../amount/amount.component";

@Component({
    selector: '[giftshop-list-item]',
    templateUrl: './giftshop.list.item.component.html',
    providers: []
})
export class GiftshopListItemComponent implements OnInit, OnChanges {

    /**
     * The current donation
     */
    @Input() currency: string;

    /**
     * list of available products
     */
    @Input() product: Product;

    /**
     * Is the item selected
     */
    @Input() selected: boolean = false;

    /**
     * Eventemitter when an item is put to the cart
     */
    @Output() addItem: EventEmitter<{ product: Product, count: number, price: number}> = new EventEmitter();

    /**
     * Eventemitter if an item is selected
     */
    @Output() itemSelected: EventEmitter<Product> = new EventEmitter();

    /**
     * Holds the DOM element
     */
    @ViewChild('shopItem') shopItem: ElementRef;

    /**
     * HOlds the item description
     */
    @ViewChild('shopItemDescription') shopItemDescription: ElementRef;

    /**
     * Formgroup for validating the input in some cases.
     */
    form: FormGroup;

    /**
     * The number of items to put into the chart
     */
    itemCount: number = 1;

    /**
     * has this item a free price selection
     */
    freePrice: boolean = false;

    /**
     * Holds the price value if there is a free price selection
     */
    priceValue: number = null;

    /**
     * path to the product image
     */
    image: string;

    /**
     * holds a style definition for the height of the element if it is active
     */
    height: string;

    /**
     * holds teh base height before the item is activated
     */
    baseHeight: number;

    /**
     * holds a style definition for the bottom-margin of the element if it is active
     */
    margin: string;

    /**
     * toggle if the form is valid or not.
     */
    validForm: boolean = true;

    /**
     * constructor
     * @param optionService
     */
    constructor(private optionService: OptionService) {}

    /**
     * @inheritDoc
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {
        if(changes.hasOwnProperty('selected') && changes.selected.firstChange === false) {
            // if deselected, reset the Itemcount
            if(changes.selected.previousValue === true && changes.selected.currentValue === false) {
                setTimeout(() => {
                    this.height = "";
                    this.margin = "";
                    this.itemCount = 1;
                    document.getElementById('twingleBodyWrapper').style.paddingBottom = null;
                }, 0);
            }
            else if(changes.selected.currentValue === true) {
                setTimeout(() => {
                    const extraHeight = this.shopItemDescription.nativeElement.offsetHeight;
                    // if selected, set height and margin
                    this.height = (this.baseHeight + extraHeight) + "px";
                    this.margin = "-" + extraHeight + "px";

                    // if the item is outside the visible content, add some padding to the main wrapper. Can happen with extra long product texts and on the last line of the list
                    if((this.shopItem.nativeElement.getBoundingClientRect().bottom + extraHeight) > window.innerHeight) {
                        document.getElementById('twingleBodyWrapper').style.paddingBottom = extraHeight + 'px';
                    }
                }, 0);
            }
        }
    }

    /**
     * @inheritDoc
     */
    ngOnInit(): void {
        this.form = new FormGroup({});

        this.form.statusChanges.subscribe(() => this.updateValidationStatus());

        // check if we have a free price input
        this.freePrice = this.product.price === null;

        if(this.freePrice === true) {
            this.form.addControl('price', new FormControl(null, [Validators.required, Validators.min(1), Validators.max(AmountComponent.SHOP_MAX)]));
        }

        // set the items image path, filter for images that are not used on the card
        if(this.product.images && this.product.images.length > 0) {
            this.image = this.optionService.getImageDirectory() + '/' + this.product.images.filter(image => (image.forgift === false || image.forgift === null))[0].file;
        }

        setTimeout(() => this.updateBaseHeight(), 500);
    }

    /**
     * Update the basHeigth of the element
     */
    @HostListener("window:resize")
    updateBaseHeight(): void {
        this.baseHeight = this.shopItem.nativeElement.offsetHeight;
    }

    /**
     * UPdates the validation status of the current item.
     */
    updateValidationStatus(): void {
        // hack for avoiding errors in the change detection of angular.
        setTimeout(() => this.validForm = this.form.valid, 0);
    }

    /**
     * descrease the itemcount
     */
    minus(): void {
        if(this.selected === false) {
            this.selectItem();
        }
        this.itemCount = this.itemCount > 1? this.itemCount - 1 : 1
    }

    /**
     * increase the itemcount
     */
    plus(): void {
        if(this.selected === false) {
            this.selectItem();
        }
        this.itemCount = this.itemCount + 1
    }

    /**
     * Get the items description. Replace some placeholders
     */
    getDescription(): string {
        return this.product.description.replace('\{\{count\}\}', this.itemCount.toString());
    }

    /**
     * user selects an item
     */
    selectItem(): void {
        if(this.selected === false) {
            this.selected = true;
            this.itemSelected.emit(this.product);
        }
        else if(this.selected === true) {
            this.personalizeItem();
        }
    }

    /**
     * add the current product and the choosen count to the cart
     */
    personalizeItem(): void {
        this.addItem.emit({product: this.product, count: this.itemCount, price: this.freePrice? this.priceValue : null});
    }

    /**
     * toggle for showing/hiding the error message on free price items
     */
    showErrorMessage(): boolean {
        if(this.freePrice === true) {
            return this.form.get('price').invalid && this.priceValue != null;
        }
        return false;
    }

}
